export const QUESTS = [
  {
    title: 'Bootstrap the Knowledge Graph',
    description:
      'Contribute foundational knowledge that helps newcomers and power-users explore web3 with confidence.',
    link: '/quests/questions',
    enabled: true,
    index: 1,
  },
  {
    title: 'Map the Crypto Ecosystems',
    description:
      'Map the major protocols, applications, and services on different blockchains, giving builders and users a chain-aware guide for each Web3 ecosystem.',
    link: '/quests/ecosystems',
    enabled: true,
    index: 2,
  },
  {
    title: 'Personalize the Graph',
    description: 'Share your unique perspectives to shape how AI and applications respond to you everywhere.',
    link: '/quests/preferences',
    enabled: true,
    index: 3,
  },
]

export const WHITELISTED_ADDRESSES = [
  "0xD99811847E634d33f0DAcE483c52949bEc76300F", //Calum
  "0xBb285b543C96C927FC320Fb28524899C2C90806C", //Calum
  "0x0b162525C5dc8c18F771E60fD296913030Bfe42c", //Tibor
  "0xbd2DE08aF9470c87C4475117Fb912B8f1d588D9c", //Voto
  "0xB95ca3D3144e9d1DAFF0EE3d35a4488A4A5C9Fc5", //Vital
  // '0x81766f4ead4d3b35d1a46fbfaaf0c557ff1a860b', // Fvngabill
]

